import { render, staticRenderFns } from "./ListOfCards.vue?vue&type=template&id=1f4e3d23&scoped=true&"
import script from "./ListOfCards.vue?vue&type=script&lang=js&"
export * from "./ListOfCards.vue?vue&type=script&lang=js&"
import style0 from "./ListOfCards.vue?vue&type=style&index=0&id=1f4e3d23&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e3d23",
  null
  
)

export default component.exports